import { MdShoppingCart, MdWorkHistory } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { RiDashboardFill } from "react-icons/ri";
import { FaSignOutAlt } from "react-icons/fa";
import { Navigate } from "react-router-dom";
import { HiOutlineX } from "react-icons/hi";
import { IoHome } from "react-icons/io5";
import { isEmpty } from "lodash";

import { setIsCloseMenu } from "../../../redux/actions/menuActions/menuActions";

import Logo from "../../../helpers/Logo/Logo";
import { decodeJWT } from "../../../utils";

const PublicMobileMenu = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isMenuOpen = useSelector((state) => state.isOpenMenu);

  const token = localStorage.getItem("token");

  const isLogin = !isEmpty(token);

  const roleName = decodeJWT(token)?.usertype;

  if (!isLogin) return <Navigate to="/" replace />;

  return (
    <div
      className={`${
        isMenuOpen
          ? "none animate__animated animate__fadeInRight animate__faster"
          : "animate__animated animate__fadeOutRight animate__faster hidden"
      } fixed top-0 w-7/12 z-50 lg:hidden none bg-menuBackground
      rounded-tl-xl rounded-bl-xl h-screen

       `}
    >
      <div className="flex flex-col justify-start items-center w-full h-full space-y-5">
        {/* Logo - Close Button */}
        <div className="flex w-full justify-center items-center">
          {/* Logo */}
          <Link
            to="/Public/Home"
            onClick={() => dispatch(setIsCloseMenu())}
            className="flex flex-col items-center py-3 px-6 mt-2.5"
          >
            <Logo width={115} height={28} />
          </Link>
          {/* Close Icon */}
          <span className="absolute top-2 right-1.5">
            <span>
              <HiOutlineX
                size={30}
                onClick={() => dispatch(setIsCloseMenu())}
                className="text-white cursor-pointer z-30"
              />
            </span>
          </span>
        </div>
        {/* Buttons - Publisher Text */}
        <span className="flex flex-col justify-between w-11/12 h-full">
          {/* Buttons - Publisher Text */}
          <span className="h-full w-full flex flex-col items-center space-y-5 py-2 relative">
            {/* 1 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Public/Home"
              className={`${
                location.pathname === "/Public/Home"
                  ? "bg-[#255F38]"
                  : "bg-[#18230F]"
              } flex items-center px-4 py-3 w-full rounded-xl
             hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300`}
            >
              <IoHome size={30} />
              <span className="mx-2">خانه</span>
            </Link>
            {/* 2 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Public/Live-Transactions"
              className={`flex items-center px-4 py-3 w-full rounded-xl
                ${
                  location.pathname === "/Public/Live-Transactions"
                    ? "bg-[#255F38]"
                    : "bg-[#18230F]"
                } flex items-center px-4 py-3 w-full rounded-xl
             hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300`}
            >
              <MdShoppingCart size={30} />
              <span className="mx-2">معاملات فعال</span>
            </Link>
            {/* 3 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Public/Last-Transactions"
              className={`flex items-center px-4 py-3 w-full rounded-xl
                ${
                  location.pathname === "/Public/Last-Transactions"
                    ? "bg-[#255F38]"
                    : "bg-[#18230F]"
                } flex items-center px-4 py-3 w-full rounded-xl
             hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300`}
            >
              <MdWorkHistory size={30} />
              <span className="mx-2">تاریخچه معاملات</span>
            </Link>
            {/* 4 */}
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to={
                roleName === "ADMIN"
                  ? "/Admin/Dashboard/Profile"
                  : "/Customer/Profile"
              }
              className="flex items-center px-4 py-3 w-full rounded-xl
            bg-[#18230F] hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300"
            >
              <RiDashboardFill size={30} />
              <span className="mx-2">
                پنل {roleName === "ADMIN" ? "ادمین" : "کاربر"}
              </span>
            </Link>
            {/* Publisher Text */}
            <div className="absolute bottom-2 flex justify-center items-center w-full">
              <span className="text-xs text-slate-200 text-center leading-relaxed">
                طراحی و توسعه توسط
                <a
                  href="http://nimasaneei.ir/"
                  rel="noreferrer"
                  target="_blank"
                  className="font-medium tracking-wide px-0.5 text-publisher"
                >
                  NimaSN
                </a>
              </span>
            </div>
          </span>
          {/* Exit */}
          <span className="w-full flex py-5">
            <Link
              onClick={() => dispatch(setIsCloseMenu())}
              to="/Log-Out"
              className="flex items-center px-4 py-3 w-full rounded-xl
            bg-[#255F38] hover:bg-[#1F7D53] cursor-pointer text-white
              transition duration-300"
            >
              <FaSignOutAlt size={30} />
              <span className="mx-2">خروج</span>
            </Link>
          </span>
        </span>
      </div>
    </div>
  );
};

export default PublicMobileMenu;
